var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 100,
    viewBox: "0 0 170 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6459_423034)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    transform: "matrix(-1 0 0 1 75 25)",
    fill: "#64748B",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 30.5,
    r: 30.5,
    transform: "matrix(-1 0 0 1 160 0)",
    fill: "#64748B",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 91,
    r: 9,
    fill: "#173261"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 73.5,
    r: 1.5,
    fill: "#173261"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.5,
    cy: 88.5,
    r: 1.5,
    fill: "#828F9C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135.5,
    cy: 8.5,
    r: 1.5,
    fill: "#173261"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 41,
    r: 3,
    fill: "#828F9C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 29,
    r: 4,
    fill: "#828F9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.143 60.2857H98.5314L97.2514 59.0514C101.731 53.84 104.429 47.0743 104.429 39.7143C104.429 31.8336 101.298 24.2756 95.7255 18.7031C90.153 13.1306 82.595 10 74.7143 10C66.8336 10 59.2756 13.1306 53.7031 18.7031C48.1306 24.2756 45 31.8336 45 39.7143C45 47.595 48.1306 55.153 53.7031 60.7255C59.2756 66.298 66.8336 69.4286 74.7143 69.4286C82.0743 69.4286 88.84 66.7314 94.0514 62.2514L95.2857 63.5314V67.1429L118.143 90L125 83.1429L102.143 60.2857ZM74.7143 60.2857C63.2857 60.2857 54.1429 51.1429 54.1429 39.7143C54.1429 28.2857 63.2857 19.1429 74.7143 19.1429C86.1429 19.1429 95.2857 28.2857 95.2857 39.7143C95.2857 51.1429 86.1429 60.2857 74.7143 60.2857ZM63.2857 37.4286H86.1429V42H63.2857V37.4286Z",
    fill: "#173261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2857 37.4286H86.1429V42H63.2857V37.4286Z",
    fill: "#828F9C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6459_423034"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 170,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchEmpty);
export default __webpack_public_path__ + "static/media/SearchEmpty.c37bccd36ca3e45e3f1d38bcfbfa2011.svg";
export { ForwardRef as ReactComponent };